import { createContext, useContext } from 'react';

import { type FileViewerComponents } from './FileViewer.components'
import { type FileViewerStrings, strings } from './FileViewer.strings'
import { type IFileData } from '../File/File'

export interface FileViewerContext<FileType = IFileData> {
  files: FileType[]
  selectedFile: FileType
  selectFile: (file: FileType) => void
  getFileData: (file: FileType) => IFileData
  isFileSelected: (file: FileType, selectedFile: FileType) => boolean
  Components: FileViewerComponents<FileType>
  strings: FileViewerStrings
}

export const FileViewerContext = createContext<FileViewerContext<any>>({
  Components: null,
  files: [],
  selectedFile: null,
  getFileData: (file) => file,
  isFileSelected: (file, selectedFile) => {
    return file === selectedFile
  },
  selectFile: () => undefined,
  strings,
})

export const useFileViewerContext = <FileType extends object = IFileData>() =>
  useContext<FileViewerContext<FileType>>(FileViewerContext)
